export const COLOR_PRIMARY = "#0f2a45";
export const COLOR_ACCENT = "#59c7b1";
export const COLOR_ACTION = "#F97316";
export const LOGO_SRC = "../../public/assets/Logo.png";
